import './App.css';

// react =>
import { Route, Routes } from 'react-router-dom';

// Pages =>
import Analys from "./Pages/Analys/Analys";
import MainPage from "./Pages/MainPage/MainPage";

function App() {
  return (
    <Routes>
      <Route path='/' element={ <MainPage /> } />
      <Route path='/analys' element={ <Analys /> } />
    </Routes>
  );
}

export default App;
